export default {"src":"/_next/static/image/src/components/BillingInformationForm/stripe-text.4d7c5f766699af910436895e514186aa.svg","height":14,"width":34};